import Model from '@/store/model';
import PerfectLessons from './perfect_lessons'; /* eslint-disable-line */
import CollectedStars from './collected_stars'; /* eslint-disable-line */
import Vocabulary from './vocabulary'; /* eslint-disable-line */

class ThematicStatistic extends Model {
  map(json) {
    super.map(json);

    if (json.perfect_lessons !== undefined && json.perfect_lessons !== null) {
      this.perfectLessons = new PerfectLessons();
      this.perfectLessons.map(json.perfect_lessons);
    }

    if (json.collected_stars !== undefined && json.collected_stars !== null) {
      this.collectedStars = new CollectedStars();
      this.collectedStars.map(json.collected_stars);
    }

    if (json.vocabulary !== undefined && json.vocabulary !== null) {
      this.vocabulary = new Vocabulary();
      this.vocabulary.map(json.vocabulary);
    }
  }
}
export default ThematicStatistic;
